import { H1, useBreadcrumbs } from "@inmagik/magik-ui"
import Layout from "../../components/Layout"
import { Tag } from "../../types"
import { useNavigate } from "react-router-dom"
import { Formik } from "formik"
import { Container } from "react-bootstrap"
import BottomFormFixed from "../../components/BottomFormFixed"
import { initialValuesTag, validationSchemaTag } from "./TagCommon"
import { useMemo } from "react"
import { useTagCreate } from "../../hooks/tags"
import TagForm from "./TagForm"
import { ScrollLayout } from "../../components/ScrollLayout"
import { transformErrorForForm } from "../../utils/utils"

export default function TagCreate() {
  const createTag = useTagCreate()
  const navigate = useNavigate()

  useBreadcrumbs([{ label: "Tags", href: "/tags/tags" }, { label: "Creazione Tag" }])

  const initialValues = useMemo(() => initialValuesTag(), [])
  const validationSchema = useMemo(() => validationSchemaTag(), [])

  return (
    <Layout>
      <ScrollLayout hasBottomFixed>
        <H1>Nuovo tag</H1>
        <ScrollLayout.Scroll>
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values, actions) => {
              return createTag.mutateAsync(values as Tag).then((tag) => {
                navigate(`/tags/tags`)
              }).catch((e) => {
                actions.setErrors(transformErrorForForm(e))
              })
            }}
          >
            {({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <Container fluid className="mt-6" style={{ marginBottom: "100px" }}>
                  <TagForm />
                </Container>
                <BottomFormFixed url="/opere/persone" />
              </form>
            )}
          </Formik>
        </ScrollLayout.Scroll>
      </ScrollLayout>
    </Layout>
  )
}
